module.exports = __webpack_public_path__ + "img/undraw_towing_6yy4.23d794be.svg";